export default "\nuniform float t;\nuniform vec3 color;\nuniform float depth;\n\nvarying vec2 vUv;\n\nvoid main() {\n  float d = length(gl_PointCoord - vec2(0.5, 0.5));\n  if(vUv.x >= t || d >= 0.5) discard;\n  gl_FragColor = vec4(color.xyz, 1.0 - depth);\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/assets/shaders/screw/screw.frag
// module id = Y4yz
// module chunks = 1